// extracted by mini-css-extract-plugin
module.exports = {"loader":"IconEdit_loader__1DfMs","root":"IconEdit_root__1H3X2","pencil":"IconEdit_pencil__24G-d"};